import es from 'date-fns/locale/es';
import moment from 'moment';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { default as React, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as PROFILE from "../../../constants/profile";
import { useAuth } from '../../../hooks/useAuth';

registerLocale('es', es)

function RoutesReportByStatus() {

  // next data is gonna be comments (Observaciones)

  // #region vars and consts

  const { hasPermission } = useAuth();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [routeStatuses, setRouteStatuses] = useState([]);
  const [selectedRouteStatus, setSelectedRouteStatus] = useState(null);  
  const [report, setReport] = useState([]);    
  const [globalFilter, setGlobalFilter] = useState('');
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },    
    "routeId": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    "url": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    "vehicleNo": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'outAirportDateT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'inAirportDateT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    "zoneRouteDesc": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },        
    'inRouteDate': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'outRouteDate': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'maxCoord': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'enterZoneDateT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'statusRouteDesc': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    "externalOrderId": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    "price": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    "zone": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'purchaseDateT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'comments': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
  });

  // #endregion

  // #region methods

  const getRouteStatuses = () => {
    fetch(`${process.env.REACT_APP_API_URL}/routeStatus/cmb`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setRouteStatuses(data.responseObject);
        } else {
          console.warn('Error getting Route Statuses', data);
        }
      });
  };  

  const getReport = (
    startDate,
    endDate,
    statusRouteId
  ) => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/route/findOrderRouteByStatus`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        startDate,
        endDate,
        statusRouteId
      })
    }).then(response => response.json()).then(data => {      
      if (data.responseCode === 'OK') {                
        console.log("Report", data.responseObject);
        setReport(data.responseObject);     
      }
      setLoading(false);
    });
  }

  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }

  const exportAsExcel = () => {
    import('xlsx').then(xlsx => {
      const heading = [[
        "Folio vuelta", 
        "Liga detalle", 
        "Vehículo", 
        "Salida Aeropuerto", 
        "Entrada Aeropuerto", 
        "Zona retorno", 
        "Entrada retorno", 
        "Salida retorno", 
        "Punto Coord retorno", 
        "Punto hora retorno", 
        "Estado", 
        "No. servicio", 
        "Precio", 
        "Zona", 
        "Fecha de compra", 
        "Observaciones"
      ]];      
      const reportToExport = report.map(item => ({
        routeId: item.routeId,
        url: item.url,
        vehicleNo: item.vehicleNo,
        outAirportDate: item.outAirportDate,        
        inAirportDate: item.inAirportDate,        
        zoneRouteDesc: item.zoneRouteDesc,
        inRouteDate: item.inRouteDate,        
        outRouteDate: item.outRouteDate,        
        maxCoord: item.maxCoord,
        enterZoneDate: item.enterZoneDate,        
        statusRouteDesc: item.statusRouteDesc,        
        externalOrderId: item.externalOrderId,
        price: item.price,
        zone: item.zone,
        purchaseDate: item.purchaseDate,
        comments: item.comments        
      }));         
      const worksheet = xlsx.utils.json_to_sheet(reportToExport, { origin: 'A2', skipHeader: true });
      xlsx.utils.sheet_add_aoa(worksheet, heading, { origin: 'A1' });
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      const fileName = 'ReporteDeRutasPorEstatus';
      import('file-saver').then(module => {
        if (module && module.default) {
          let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
          let EXCEL_EXTENSION = '.xlsx';
          const data = new Blob([excelBuffer], {
            type: EXCEL_TYPE
          });
          module.default.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
        }
      });
    });
  };

  // #endregion

  // #region events

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilter(value);
  };

  const onSearchButtonPress = () => {
    setReport([]);
    getReport(
      startDate.valueOf(),
      endDate.valueOf(),     
      selectedRouteStatus ? selectedRouteStatus.routeStatusId : null      
    );
  };

  const onExportExcelButtonPress = () => {
    exportAsExcel();
  };

  const onRouteStatuschange = (e) => {
    setSelectedRouteStatus(e.value);
  };

  useEffect(() => {
    scrollToTop();
    getRouteStatuses();
  }, []);

  // #endregion

  // #region templates

  const filtersTemplate = (
    <>
      <Row className='align-items-end'>
        <Col xs={12} sm={6} md={3} className='mb-2'>
          <Form.Group>
            <Form.Label>
              Fecha inicial
            </Form.Label>
            <DatePicker
              controlId="startDateInput"
              dateFormat="dd/MMM/yyyy"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              locale="es"
              className="w-100 app_datepicker" />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3} className='mb-2'>
          <Form.Group>
            <Form.Label>
              Fecha final
            </Form.Label>
            <DatePicker
              controlId="endDateInput"
              dateFormat="dd/MMM/yyyy"
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              locale="es"
              className="w-100 app_datepicker" />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3} className='mb-2'>
          <Form.Group>
            <Form.Label>
              Estatus de Ruta
            </Form.Label>
            <Dropdown
              value={selectedRouteStatus}
              options={routeStatuses}
              onChange={onRouteStatuschange}
              optionLabel="description"
              placeholder="Selecciona el Estatus de Ruta"
              className='p-inputtext-sm w-100 app_dropdown'
              showClear
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3} className='mb-2'>
          <Button
            type="button"
            icon="pi pi-search"
            onClick={onSearchButtonPress}
            className="p-button-raised p-button-sm p-button-primary p-fluid w-100"
            label='Buscar'
            disabled={
              startDate === null
              || endDate === null
              || selectedRouteStatus === null
            }
          />
        </Col>
      </Row>
    </>
  );

  const reportHeaderTemplate = (
    <>
      <Row>
        <Col>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText value={globalFilter} onChange={onGlobalFilterChange} placeholder="Filtrar" className='p-inputtext-sm' />
          </span>
        </Col>
        <Col>
          {
            hasPermission(PROFILE.PERMISSIONS.DOWNLOAD_REPORTS) && (
              <Button type="button" icon="pi pi-file-excel" onClick={onExportExcelButtonPress} className="p-button-raised p-button-sm p-button-success mr-2 float-end" data-pr-tooltip="XLS" label='Exportar' />
            )
          }
        </Col>
      </Row>
    </>
  );

  const purchaseDateTColumnTemplate = (row) => {
    const purchaseDateT = row.purchaseDateT;
    if (purchaseDateT > 0) {
      const purchaseDateTMoment = moment(purchaseDateT);
      return (
        <span>{purchaseDateTMoment.format("DD/MM/YYYY hh:mm:ss a")}</span>
      );
    } else { 
      return <></>;
    }    
  };

  const urlColumnTemplate = (row) => {
    return (
      <>
        {
          (row.url && row.url.trim() !== '') && (
            <>
              <a                
                rel="noreferrer" 
                href={row.url}
                target='_blank'
              >
                {row.url.trim()}
              </a>
            </>
          )
        }
      </>
    )
  };

  const outAirportDateTTemplate = (row) => {
    const outAirportDateT = row.outAirportDateT;
    if (outAirportDateT > 0) {
      const outAirportDateTMoment = moment(outAirportDateT);
      return (
        <span>{outAirportDateTMoment.format("DD/MM/YYYY hh:mm:ss a")}</span>
      );
    } else {
      return <></>;
    }
  };

  const inAirportDateTTemplate = (row) => {
    const inAirportDateT = row.inAirportDateT;
    if (inAirportDateT > 0) {
      const inAirportDateTMoment = moment(inAirportDateT);
      return (
        <span>{inAirportDateTMoment.format("DD/MM/YYYY hh:mm:ss a")}</span>
      );
    } else {
      return <></>;
    }
  };

  const inRouteDateTTemplate = (row) => {
    const inRouteDateT = row.inRouteDateT;
    if (inRouteDateT > 0) {
      const inRouteDateTMoment = moment(inRouteDateT);
      return (
        <span>{inRouteDateTMoment.format("DD/MM/YYYY hh:mm:ss a")}</span>
      );
    } else {
      return <></>;
    }
  };

  const outRouteDateTTemplate = (row) => {
    const outRouteDateT = row.outRouteDateT;
    if (outRouteDateT > 0) {
      const outRouteDateTMoment = moment(outRouteDateT);
      return (
        <span>{outRouteDateTMoment.format("DD/MM/YYYY hh:mm:ss a")}</span>
      );
    } else {
      return <></>;
    }
  };
  
  const enterZoneDateTTemplate = (row) => {
    const enterZoneDateT = row.enterZoneDateT;
    if (enterZoneDateT > 0) {
      const enterZoneDateTMoment = moment(enterZoneDateT);
      return (
        <span>{enterZoneDateTMoment.format("DD/MM/YYYY hh:mm:ss a")}</span>
      );
    } else {
      return <></>;
    }
  };

  const reportByDriverTemplate = (
    <>
      <div>
        <div className="card">
          <DataTable
            value={report}
            paginator
            className="p-datatable-customers"
            showGridlines
            stripedRows
            header={reportHeaderTemplate}
            rows={50}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[10, 25, 50]}
            filters={filters}
            filterDisplay="menu"
            loading={loading}
            responsiveLayout="scroll"
            globalFilterFields={[
              'routeId',
              'url',
              'vehicleNo',
              'outAirportDateT',
              'inAirportDateT',
              'zoneRouteDesc',
              'inRouteDate',
              'outRouteDate',
              'maxCoord',
              'enterZoneDateT',
              'statusRouteDesc',              
              'externalOrderId',
              'price',
              'zone',
              'purchaseDateT',
              'comments'
            ]}
            emptyMessage="No records found."
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"                   
          >            
            <Column field="routeId" header="Folio vuelta" sortable filter filterPlaceholder="Buscar por Folio vuelta" className='app-w-150-px text-end' />
            <Column field="url" header="Liga detalle" sortable filter filterPlaceholder="Buscar por Liga detalle" className='app-w-250-px text-start' body={urlColumnTemplate} />
            <Column field="vehicleNo" header="Vehículo" sortable filter filterPlaceholder="Buscar por Vehículo" className='app-w-100-px text-start' />        
            <Column field="outAirportDateT" header="Salida Aeropuerto" sortable filter filterPlaceholder="Buscar por Salida Aeropuerto" className='app-w-300-px text-start' body={outAirportDateTTemplate} />
            <Column field="inAirportDateT" header="Entrada Aeropuerto" sortable filter filterPlaceholder="Buscar por Entrada Aeropuerto" className='app-w-300-px text-start' body={inAirportDateTTemplate} />
            <Column field="zoneRouteDesc" header="Zona retorno" sortable filter filterPlaceholder="Buscar por Zona retorno" className='app-w-200-px text-start' />
            <Column field="inRouteDateT" header="Entrada retorno" sortable filter filterPlaceholder="Buscar por Salida retorno" className='app-w-300-px text-start' body={inRouteDateTTemplate} />
            <Column field="outRouteDateT" header="Salida retorno" sortable filter filterPlaceholder="Buscar por Entrada retorno" className='app-w-300-px text-start' body={outRouteDateTTemplate} />
            <Column field="maxCoord" header="Punto Coord retorno" sortable filter filterPlaceholder="Buscar por Punto Coord retorno" className='app-w-200-px text-start' />
            <Column field="enterZoneDateT" header="Punto hora retorno" sortable filter filterPlaceholder="Buscar por Punto hora retorno" className='app-w-300-px text-start' body={enterZoneDateTTemplate} />
            <Column field="statusRouteDesc" header="Estado" sortable filter filterPlaceholder="Buscar por Estado" className='app-w-200-px text-start' />
            <Column field="externalOrderId" header="No. servicio" sortable filter filterPlaceholder="Buscar por No. servicio" className='app-w-250-px text-end' />
            <Column field="price" header="Precio" sortable filter filterPlaceholder="Buscar por Precio" className='app-w-250-px text-end' />
            <Column field="zone" header="Zona" sortable filter filterPlaceholder="Buscar por Zona" className='app-w-200-px text-start' />
            <Column field="purchaseDateT" header="Fecha de compra" sortable filter filterPlaceholder="Buscar por Fecha de compra" className='app-w-300-px text-start' body={purchaseDateTColumnTemplate} />            
            <Column field="comments" header="Observaciones" sortable filter filterPlaceholder="Buscar por Observaciones" className='app-w-200-px text-start' />
          </DataTable>
        </div>
      </div>
    </>
  );

  // #endregion

  return (
    <>
      <article>
        <Row>
          <Col>
            <h1 className='app-font'>
              Reporte de Rutas por Estatus
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            {filtersTemplate}
          </Col>
        </Row>
        <Row className='pt-2'>
          <Col>
            {reportByDriverTemplate}
          </Col>
        </Row>  
      </article>
    </>
  );
}

export default RoutesReportByStatus;